'use client';

import { Box, Grid, Typography } from '@mui/material';
import EmptyState from '../EmptyState';
import { IconSvg } from '../Icon';
import AddComment from './AddComment';
import Comment from './Comment';
import { useComments } from '@/api/hooks/useComments';
import { usePdpInfo } from '@/api/hooks/usePdpInfo';
const Comments = () => {
  const texts = {
    emptyStateDesc: 'تاکنون نظری برای این طرح ثبت نشده است'
  };
  const {
    data,
    isLoading
  } = useComments();
  const {
    data: dataInfo
  } = usePdpInfo();
  return <Grid container sx={{
    width: '100%',
    bgcolor: 'background.bg',
    justifyContent: 'center',
    borderRadius: {
      md: 'var(--corner_radius_m)'
    },
    px: 'var(--spacing_m)',
    py: 'var(--spacing_m_nudge)',
    my: 'var(--spacing_m)',
    rowGap: 'var(--spacing_m)'
  }} data-sentry-element="Grid" data-sentry-component="Comments" data-sentry-source-file="Comments.tsx">
      <Box sx={{
      width: '100%',
      gap: 'var(--spacing_xs)',
      display: 'flex'
    }} data-sentry-element="Box" data-sentry-source-file="Comments.tsx">
        <IconSvg component={'MessageBaloonsAccent'} width='32' height='32' data-sentry-element="IconSvg" data-sentry-source-file="Comments.tsx" />
        <Typography variant='headlineStrong__Wallfund' color='text.text' flex={1} data-sentry-element="Typography" data-sentry-source-file="Comments.tsx">
          نظرات
        </Typography>
        {dataInfo.addComments && <AddComment />}
      </Box>
      {dataInfo.showComments && data?.length > 0 && !isLoading ? (data || []).map(comment => <Comment key={comment.id} {...comment} />) : <EmptyState desc={texts.emptyStateDesc} />}
      {/* <Button color='primary'>دیدن بیشتر</Button> */}
    </Grid>;
};
export default Comments;